module.exports = __webpack_public_path__ + "img/publicationDates.55f2210e.svg";